export function resolveTurnstileSiteKey() {
  return String(
    process.env.NEXT_PUBLIC_TURNSTILE_SITE_KEY
      || process.env.NEXT_PUBLIC_CLOUDFLARE_TURNSTILE_SITE_KEY
      || ""
  ).trim();
}

export function resolveTurnstileEnabled() {
  const raw = String(process.env.NEXT_PUBLIC_TURNSTILE_ENABLED ?? "").trim().toLowerCase();
  if (raw === "0" || raw === "false" || raw === "off") return false;
  return true;
}

